<div class="modal notification-modal mic-check-modal" tabindex="-1" role="dialog" *ngIf="activateModal">

    <div class="modal-dialog" *ngIf="currentStep !== microphoneCheckStep.NUMBER_TEST_ERROR">
        <div class="modal-content container-fluid">

            <div class="modal-button row">
                <div class="col-xs-4"></div>
                <div class="col-xs-4"></div>
                <div class="col-xs-4 pull-right no-gutter">
                    <button type="button" class="close btn-black-close"
                            (click)="cancel(true)" [disabled]="recordingService.microphoneCheckActive"
                            data-dismiss="modal" aria-label="Close"></button>
                </div>
            </div>

            <div class="modal-body">
                
                <div class="mic-setup" *ngIf="currentStep === microphoneCheckStep.MICROPHONE_REQUESTED">

                    <div class="row mic-content pb-1">
                        <div class="col-sm-2">
                            <div class="img-little-girl"></div>
                        </div>

                        <div class="col-xs-6 pt-1 pr-0 pl-0">
                            <div class="modal-title" [innerHTML]="title"></div>
                            <p class="instruction-text" [innerHTML]="message"></p>
                        </div>

                        <div class="col-xs-2"></div>
                    </div>

                    <div class="row btn-group-lg">
                        <div class="col-xs-1"></div>
                        <div class="col-xs-10">
                            <div *ngIf="browser == 'Chrome'" class="img-chrome-mic-setup"></div>
                            <div *ngIf="browser == 'Edge'" class="img-edge-mic-setup"></div>
                            <div *ngIf="browser == 'Firefox'" class="img-firefox-mic-setup"></div>
                            <!--Safari is not implemented because desktop Safari is not supported-->
                            <div *ngIf="browser == 'Safari'" class="img-safari-mic-setup">
                                <button class="mic-button btn-lg" (click)="setNumbersTestCheck(true)">Next</button>
                            </div>
                        </div>
                        <div class="col-xs-1"></div>
                    </div>

                    <div class="row microphone-check-error py-2">
                        <div class="col-xs-12 px-0 text-center error-text" *ngIf="errorText != null"
                             [innerHTML]="errorText"></div>
                    </div>

                </div>

                <div class="mic-check-intro" *ngIf="currentStep === microphoneCheckStep.MICROPHONE_CHECK">

                    <div class="row mic-content">
                        <div class="col-sm-2 pt-2 mic-image-block">
                            <div class="img-little-girl"></div>
                        </div>
                        
                        <div class="col-xs-7 pr-0 pl-0 pt-1">
                            <div class="modal-title" [innerHTML]="title"></div>
                            <p class="instruction-text" [innerHTML]="message"></p>
                        </div>

                        <div class="col-xs-1"></div>
                    </div>

                    <div class="modal-button">
                        <div class="col-xs-4"></div>
                        <div class="col-xs-4 pb-3 text-center btn-group btn-group-lg-align-center">
                            <button class="mic-button btn-lg" (click)="setNumbersTestCheck(true)">Next</button>
                        </div>
                        <div class="col-xs-4"></div>
                    </div>
                </div>


                <div class="mic-check-intro-numbers" *ngIf="currentStep === microphoneCheckStep.NUMBER_TEST">
                    <div class="row mic-content">
                        <div class="col-sm-2 pt-2 pr-0 mic-image-block">
                            <div class="img-microphone"></div>
                        </div>
                    
                    <div class="col-xs-7 pl-0 pt-1 img-number-panel-overlay-parent">
                        <div class="modal-title" [innerHTML]="title"></div>
                        <div class="col-xs-12 px-0"></div>
                        <div class="col-xs-12 px-0 number-panel-numbers">
                            <div class="row number-panel">
                                <div class="number-panel-numbers-text">1</div>
                                <div class="number-panel-numbers-text">2</div>
                                <div class="number-panel-numbers-text">3</div>
                                <div class="number-panel-numbers-text">4</div>
                                <div class="number-panel-numbers-text">5</div>
                                <div class="number-panel-numbers-text">6</div>
                                <div class="number-panel-numbers-text">7</div>
                                <div class="number-panel-numbers-text">8</div>
                                <div class="number-panel-numbers-text">9</div>
                                <div class="number-panel-numbers-text">10</div>
                                <div class="number-panel-numbers-text"></div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xs-1"></div>

                        <div class="col-xs-7 pt-0 pr-0 pl-2">
                            <div class="row pt-1">
                                <div class="col-xs-7 volume-text">Volume</div>
                            </div>
                            <div class="row pt-0">
                                <div class="col-xs-12">
                                    <div class="img-colored-bar"></div>
                                </div>
                            </div>
                            <div class="row pt-0">
                                <div class="col-xs-12 img-volume-feedback-overlay-parent">
                                    <div *ngFor="let vol of volumeBar; let i = index;" [ngClass] = "vol.volume ? 'img-volume-feedback-bar-dark' : 'img-volume-feedback-bar'"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row microphone-check-error py-2">
                        <div class="col-xs-12 px-0 text-center error-text" *ngIf="errorText != null"
                             [innerHTML]="errorText"></div>
                    </div>

                    <div class="modal-button row pt-2 pb-2">
                        <div class="col-xs-12 btn-group btn-group-lg-align-center">
                            <button type="button" class="mic-button btn-lg"
                                    [disabled]="recordingService.microphoneCheckActive"
                                    (click)="setNumbersTestCheck(false)">Retry
                            </button>
                        </div>
                    </div>
                </div>

                <div class="mic-check-completed" *ngIf="currentStep === microphoneCheckStep.COMPLETED">
                
                    <div class="row mic-content pl-1">
                        <div class="col-sm-2 pb-1">
                            <div class="img-little-girl"></div>
                        </div>

                        <div class="col-xs-7 pt-2 pl-0 pr-3">
                            <div class="modal-title" [innerHTML]="title"></div>
                            <p class="mt-1 instruction-text" [innerHTML]="contentMessage"></p>
                        </div>

                        <div class="col-xs-2"></div>
                    </div>

                    <div class="modal-button row pt-2 pb-2">
                        <div class="col-xs-12 text-center btn-group btn-group-lg-align-center">
                            <button class="mic-button btn-lg" (click)="endMicrophoneCheck()">OK</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="mic-check-error modal-dialog" *ngIf="currentStep === microphoneCheckStep.NUMBER_TEST_ERROR">
        <div class="modal-content container-fluid">
            <div class=" modal-button row">
                <div class="col-xs-4"></div>
                <div class="col-xs-4"></div>
                <div class="col-xs-4 pull-right no-gutter">
                    <button type="button" class="close btn-black-close " (click)="cancel()" data-dismiss="modal"
                            aria-label="Close"></button>
                </div>
            </div>
            <div class="modal-header row pt-1 mt-1 mb-2">
                <div class="col-xs-2 pl-2">
                    <div class="img-error"></div>
                </div>
                <div class="col-xs-10 pl-0">
                    <div class="modal-title" [innerHTML]="title"></div>
                </div>
                <div class="col-xs-2"></div>
            </div>

            <div class="modal-body">

                <div class="row">
                    <div class="col-xs-1"></div>
                    <div class="col-xs-10 instruction-text" [innerHTML]="message"></div>
                    <div class="col-xs-1"></div>
                </div>
                <div class="row">
                    <div class="col-xs-1"></div>
                    <div class="col-xs-10 pl-3">
                        <ul>
                            <li class="error-list-item instruction-text" [innerHTML]="subMessage1"></li>
                            <li class="error-list-item instruction-text" [innerHTML]="subMessage2"></li>
                            <li class="error-list-item instruction-text" [innerHTML]="subMessage3"></li>
                        </ul>
                    </div>
                    <div class="col-xs-1"></div>
                </div>

                <div class="modal-button row pt-3 pb-2 btn-group-lg-align-center">
                    <div>
                        <button class="mic-button btn-lg" (click)="setNumbersTestCheck(false)">Retry</button>
                    </div>
                    <div class="col-xs-2"></div>
                </div>
            </div>

        </div>
    </div>
</div>


<div class="modal-backdrop fade in" *ngIf="activateModal"></div>
